import { adams } from 'app/scripts/lib/adams';
import { templateHelpers } from './templateHelpers';

// eslint-disable-next-line @trello/no-module-logic
export const teacupWithHelpers = templateHelpers(adams);
